'use strict';

// init
require('./init.js');
// Sass
require('./../scss/index.scss');